import { storyblokEditable } from "@storyblok/react";

const ImageInfotext = ({ blok }) => (
    
    <div className="imageinfotext-wrap flex wrap"{...storyblokEditable(blok)}>
      <div className="imageinfotext-content flex flex">
{/*         <h2 className="text-2xl">{blok.subheadline}</h2> */}
        <img className="hide-mobile pb-4" src={blok.image.filename} alt={blok.image.alt} />
        <div className="hide-desktop imageinfotext-img">
        <img className="" src={blok.image.filename} alt={blok.image.alt} />
      </div>
      <div className="imageinfotext-text">
         <p>
          {blok.text}
        </p>
      </div>
       
        {/* <div>
          <button>{blok.button}</button>  
        </div> */}
        
      </div>

    </div>
      
);

export default ImageInfotext; 